import angular from 'angular';
import loanAppDiscountsRate from './loanAppDiscountsRate';

export default angular
  .module('components.loanAppDiscountsRate', [])
  .component('loanAppDiscountsRate', loanAppDiscountsRate).name;
